import { feeConstants } from "../actions/constants/feeConstants";

export const getFeeReducer = (state = {}, action: any) => {
    switch (action.type) {
        case feeConstants.getFeeRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case feeConstants.getFeeSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                feedata: action.payload
            }
        case feeConstants.getFeeFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getFeeParamsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case feeConstants.getFeeParamsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case feeConstants.getFeeParamsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                feedata: action.payload
            }
        case feeConstants.getFeeParamsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const createFeeReducer = (state = {}, action: any) => {
    switch (action.type) {
        case feeConstants.createFeeRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case feeConstants.createFeeSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                feedata: action.payload
            }
        case feeConstants.createFeeFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case feeConstants.createFeeReset:
            return {
                isLoading: false,
                isSuccess: false,
                isError: false
            }
        default:
            return state;
    }
}

export const deleteFeeReducer = (state = {}, action: any) => {
    switch (action.type) {
        case feeConstants.deleteFeeRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case feeConstants.deleteFeeSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                feedata: action.payload
            }
        case feeConstants.deleteFeeFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case feeConstants.deleteFeeReset:
            return {
                isLoading: false,
                isSuccess: false,
                isError: false
            }
        default:
            return state;
    }
}

export const getFeeViewReducer = (state = {}, action: any) => {
    switch (action.type) {
        case feeConstants.feeViewRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case feeConstants.feeViewSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                feeview: action.payload
            }
        case feeConstants.feeViewFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getStudentFeeSummaryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case feeConstants.getStudentFeeSummaryRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case feeConstants.getStudentFeeSummarySuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                summary: action.payload
            }
        case feeConstants.getStudentFeeSummaryFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getEnrollmentFeeHistoryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case feeConstants.getEnrollmentFeeHistoryRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false,
                fees: [],
            }
        case feeConstants.getEnrollmentFeeHistorySuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                fees: action.payload?.fees ?? action.payload?.data ?? [],
            }
        case feeConstants.getEnrollmentFeeHistoryFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                fees: [],
                error: action.payload
            }
        case feeConstants.getEnrollmentFeeHistoryReset:
            return {
                isLoading: false,
                isSuccess: false,
                isError: false,
                fees: [],
            }
        default:
            return state;
    }
}
